// Luhn's algorithm is also known as the "modulus 10" or "mod 10" algorithm.
// It is a simple checksum formula used to validate credit card numbers
// and other identification numbers. https://en.wikipedia.org/wiki/Luhn_algorithm
const isValidLuhnNumber = (cardNumberPrefix, cardNumber)=>{
    var ref, ref1;
    const CARD_NUMBER_VALIDATION_REG = new RegExp('^\\d{10}$');
    const PREFIX_NUMBER_VALIDATION_REG = new RegExp('^\\d{6}$');
    if (!((ref = PREFIX_NUMBER_VALIDATION_REG.exec(cardNumberPrefix.trim())) === null || ref === void 0 ? void 0 : ref.length)) {
        console.error('card prefix validation failed');
        return false;
    }
    if (!((ref1 = CARD_NUMBER_VALIDATION_REG.exec(cardNumber.trim())) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        console.error('card number validation failed');
        return false;
    }
    const CHECK_SUM = Number(cardNumber.at(-1));
    const cardNumbers = (cardNumberPrefix + cardNumber.substring(0, cardNumber.length - 1)).split('').map(Number).reverse();
    let sum = 0;
    cardNumbers.forEach((item, index)=>{
        if (!(index % 2)) {
            sum = item > 4 ? sum + (2 * item - 9) : sum + 2 * item;
        } else {
            sum = sum + item;
        }
    });
    return CHECK_SUM == (sum % 10 ? 10 - sum % 10 : 0);
};

export { isValidLuhnNumber };
//# sourceMappingURL=is-valid-luhn-number.js.map
